import { CommonHeaders } from './commonHeaders';

export class EntitlementHeaders extends CommonHeaders {
  public constructor(apiKey: string) {
    super(apiKey);

    this.set('X-Api-Key', apiKey);
    this.set('Authorization', 'Bearer {accessToken}');
    this.set('X-Fox-DMA', '{dma}');
  }
}
